import { EventType } from "src/store/api/generatedApi";

export const eventTypeColor = (type: EventType) => {
  switch (type) {
    case "lift":
      return "#64c8ff";
    case "drop":
      return "#ffa500";
    case "flag":
      return "#9c27b0";
  }
};
